import { render, staticRenderFns } from "./EventCategoryComponent.vue?vue&type=template&id=dfefc39e&scoped=true&"
import script from "./EventCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./EventCategoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./EventCategoryComponent.vue?vue&type=style&index=0&id=dfefc39e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfefc39e",
  null
  
)

export default component.exports